<template>
  <component :is="helpComponent" />
</template>
<script>
export default {
  props: {
    page: {
      type: String,
      required: true,
    },
  },
  computed: {
    helpComponent: function() {
      return this.page.replace(/\-/g, "").toLowerCase();
    },
  },
  created: function() {
    const requireComponent = require.context(
      "./pages",
      true,
      /[A-Z]\w+\.(vue|js)$/
    );

    requireComponent.keys().forEach((filename) => {
      const componentConfig = requireComponent(filename);
      const componentName = filename
        .split("/")
        .pop()
        .split(".")[0]
        .toLowerCase();

      this.$options.components[componentName] = componentConfig.default;
    });
  },
};
</script>
